import React from 'react';
import ToolboxSplashFiltersMobile from './Mobile/ToolboxSplashFiltersMobile';
import ToolboxSplashFiltersDesktop from './Desktop/ToolboxSplashFiltersDesktop';

const ToolboxSplashFiltersContainer = ({
  displayMobileFilters,
  filters,
  handleListItemClick,
  hasSelectedFilters,
  clearFilters,
  isSelected,
  handleFilterButtonClick,
}) => {
  const FiltersComponent = props => {
    return displayMobileFilters ? (
      <ToolboxSplashFiltersMobile {...props} />
    ) : (
      <ToolboxSplashFiltersDesktop {...props} />
    );
  };

  return (
    <FiltersComponent
      filters={filters}
      isSelected={isSelected}
      handleListItemClick={handleListItemClick}
      clearFilters={clearFilters}
      handleFilterButtonClick={handleFilterButtonClick}
      hasSelectedFilters={hasSelectedFilters}
    />
  );
};

export default ToolboxSplashFiltersContainer;
